import { render, staticRenderFns } from "./LpInputVideo.vue?vue&type=template&id=33c0999d&scoped=true"
import script from "./LpInputVideo.vue?vue&type=script&lang=js"
export * from "./LpInputVideo.vue?vue&type=script&lang=js"
import style0 from "./LpInputVideo.vue?vue&type=style&index=0&id=33c0999d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c0999d",
  null
  
)

export default component.exports